<template lang="pug">
v-card.transparent(tile flat)
    v-layout.pa-1( v-if="offerItem" :class="statusConfig.statusClass")
        v-flex.caption(disabled) {{ statusConfig.label }}
        v-icon.mr-2.ml-2(small :color="statusConfig.color") {{ statusConfig.icon }}
        v-icon.next-icon(color="primary" small) fas fa-chevron-double-right
    v-layout.pa-1( v-else :class="getEventClass()")
      v-flex.caption {{ eventName }}

</template>

<script lang="ts">
import Vue from 'vue'
import MenuGroupItem from '@/model/menu/MenuGroupItem'
import DailyMenuOfferOrder from '@/model/dailymenu/DailyMenuOfferOrder'
import MenuReservationItem from '@/model/dailymenu/MenuReservationItem'
import {Component, Prop} from "vue-property-decorator";

interface ItemStatusConfig {
  [key: string]: {
    statusClass: string
    icon: string
    color: string
    label: string
  }
}

@Component({
})
export default class CalendarGroupKindItem extends Vue {

  @Prop({ type: Object as () => MenuGroupItem }) menuGroupItem!: MenuGroupItem
  @Prop({ type: Object as () => DailyMenuOfferOrder }) offerItem!: DailyMenuOfferOrder
  @Prop({ type: Object as () => MenuReservationItem }) reservationItem!: MenuReservationItem
  @Prop({ type: String}) eventName!: string

    get statusConfig (): any {
      let config: ItemStatusConfig = {
        active: {
          statusClass: 'active',
          icon: 'fas fa-check',
          color: 'green',
          label: this.menuGroupItem.title
        },
        canceled: {
          statusClass: 'canceled',
          icon: 'fas fa-minus-square',
          color: 'red',
          label: `${this.menuGroupItem.title} - ${this.$t('orderPage.labelStornoOrder')}`
        },
        delivered: {
          statusClass: 'delivered',
          icon: 'fas fa-cookie-bite',
          color: '#8fa2c3',
          label: `${this.menuGroupItem.title} - ${this.$t('orderPage.menuOfferDelivered')}`
        },
        default: {
          statusClass: 'no-reservation',
          icon: this.reservationItem ? '' : 'fas fa-exclamation',
          color: 'gray',
          label: this.menuGroupItem.title
        }
      }

      if (this.reservationItem && config[this.reservationItem.status]) {
        if(this.reservationItem.topMenuGroup.title === this.menuGroupItem.title) {
          return config[this.reservationItem.status]

      }else{
          return config.default
        }
      }

      return config.default
    }

  getEventClass(): string {
    if (this.eventName == 'Prázdniny') {
      return 'yellow'
    } else if (this.eventName == 'Voľný deň') {
      return 'orange'
    }

    return ''
  }
}
</script>

<style lang="stylus" scoped>
.active
    background-color #c8e6c9

.canceled
    background-color #fadacd

.delivered
    background-color #c0dbff

.no-reservation
    background-color rgba(0, 0, 0, .08)

.orange
  background-color orange

.yellow
  background-color yellow

</style>
